<template lang="html">
  <article class="">
    <div class="flex flex-col bg-white rounded">
      <div
        @click="toggleContent()"
        class="cursor-pointer md:cursor-auto p-6 flex items-center justify-between gap-2"
        ref="header"
      >
        <h2 class="text-xl md:text-2xl">
          {{ config.name }} {{ apartment.id }}
        </h2>
        <div class="ml-auto md:ml-0">
          <Status :status="apartment.status" />
        </div>
        <div
          :class="[
            'block md:hidden transition-transform transform translate-x-1.5',
            !toggled && 'rotate-180',
          ]"
        >
          <svg
            width="14"
            height="9"
            viewBox="0 0 14 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.25 1.5L7 7.75L0.75 1.5"
              stroke="#232C32"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div :class="['overflow-hidden', toggled ? 'basis-0' : 'basis-1']">
        <div class="px-6 pb-6">
          <Detail
            v-for="item in apartment.details"
            :label="item.label"
            :key="item.label"
            >{{ item.value }}</Detail
          >
          <Detail label="Karta lokalu" v-if="apartment.download">
            <a
              :href="apartment.download"
              target="_blank"
              class="flex items-center gap-1"
            >
              <DownloadIcon /> Pobierz</a
            >
          </Detail>

          <div class="mt-4">
            <button :class="btnClass" @click="handleButtonClick()">
              {{ config.button }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import Detail from './Detail.vue';
import Status from './Status.vue';
import DownloadIcon from '../../DownloadIcon.vue';
export default {
  name: 'ApartmentCard',
  props: ['apartment', 'config'],
  components: {
    Detail,
    Status,
    DownloadIcon,
  },
  data: function () {
    return {
      toggled: true,
      url: window.location.origin,
      status: this.apartment.status.toLowerCase(),
      isSold: this.apartment.status.toLowerCase() == 'sprzedane',
      isReserved: this.status == 'rezerwacja',
      isAvailable: this.status == 'wolne',
    };
  },
  methods: {
    toggleContent() {
      this.toggled = !this.toggled;
    },
    handleButtonClick() {
      this.$emit('apartmentSelected', this.apartment.id);
    },
  },
  computed: {
    btnClass() {
      switch (this.apartment.status) {
        case 'Dostępne':
        case 'Dostępny':
        case 'Niedostępny':
        case 'Wkrótce':
        case 'Wkrótce w sprzeday':
          return 'py-4 px-6 rounded font-semibold inline-block text-center cursor-pointer transition-colors bg-accent-400 text-white w-full';
        case 'Sprzedany':
        case 'Sprzedane':
        case 'Rezerwacja':
        case 'Zarezerwowany':
          return 'py-4 px-6 rounded font-semibold inline-block text-center cursor-not-allowed pointer-events-none transition-colors bg-gray-300 text-gray-500 w-full';
      }
    },
    toggledStyles() {
      return this.toggled ? { flex: 1 } : { flexBasis: 0 };
    },
  },
};
</script>
